// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"4718d2d0","394":"2de15f12","631":"59611432","640":"519b5a01","664":"0861a51f"}[chunkId] + ".chunk.js";
};